import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Segment, Dimmer, Loader, Icon } from 'semantic-ui-react';
import { updateWaitingAreaSmsNotificationForm } from '../../../../actions/waitingArea.js';
import { updateShowUpdateSmsNotificationModal, updateShowCreateSmsNotificatioModal } from '../../../../actions/modal';
import HtmlToReact from 'html-to-react';
let htmlToReactParser = new HtmlToReact.Parser(React);
import objectAssign from 'object-assign';

export default function EditAlertsWaitingArea(props) {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);

  const waitingArea = useSelector((state) => {
    let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
    if (!!state.waitingAreaReducer.selectedWaitingAreaId)
      selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
        (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
      );
    const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
    return waitingArea;
  });
  const showSmsInput = (event) => {
    if (props.fetchingWaitingArea) return;
    let show = true;

    dispatch(
      updateWaitingAreaSmsNotificationForm({
        mobilePhoneNumber: waitingArea.myProviderStatus.monitorContactNumber,
        secondsIntervalToSmsSendNotification: waitingArea.myProviderStatus.secondsBeforeSendingSms,
        myProviderStatus: waitingArea.myProviderStatus,
      })
    );

    if (
      waitingArea.myProviderStatus.monitorContactNumber != '' &&
      waitingArea.myProviderStatus.monitorContactNumber != null
    ) {
      dispatch(updateShowUpdateSmsNotificationModal(show));
    } else {
      dispatch(updateShowCreateSmsNotificatioModal(show));
    }
  };

  let decideText = (minutes, intermediateRess, lowRess) => {
    let mainText = '';

    if (minutes > 1) {
      if (intermediateRess) mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsOnPluralNoBreak;
      else mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsOnPlural;

      if (lowRess) mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsTo;
      return htmlToReactParser.parse(
        '<span className="left-text ' +
          (mainText.indexOf('br') > -1 ? ' break-time' : '') +
          '">' +
          mainText
            .replace(
              '##number##',
              '<span className="bold">' + ' ' + waitingArea.myProviderStatus.monitorContactNumber + '</span>'
            )
            .replace('##time##', waitingArea.myProviderStatus.secondsBeforeSendingSms) +
          '</span>'
      );
    } else if (minutes == 1) {
      if (intermediateRess) mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsOnNoBreak;
      else mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsOn;

      if (lowRess) mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsTo;

      return htmlToReactParser.parse(
        '<span className="left-text ' +
          (mainText.indexOf('br') > -1 ? ' break-time' : '') +
          '">' +
          mainText
            .replace(
              '##number##',
              '<span className="bold">' + ' ' + waitingArea.myProviderStatus.monitorContactNumber + '</span>'
            )
            .replace('##time##', waitingArea.myProviderStatus.secondsBeforeSendingSms) +
          '</span>'
      );
    } else {
      if (lowRess) mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsToNoTime;
      else mainText = APP.LANGUAGE.ViewOneWaitingArea.AlertsNoTime;
      return htmlToReactParser.parse(
        '<span className="left-text">' +
          mainText.replace(
            '##number##',
            '<span className="bold">' + ' ' + waitingArea.myProviderStatus.monitorContactNumber + '</span>'
          ) +
          '</span>'
      );
    }
  };

  let wordSelector = (statusOfPhone) => {
    if (statusOfPhone) return APP.LANGUAGE.On.toLowerCase();
    else return APP.LANGUAGE.Off.toLowerCase();
  };
  let getStatus = (phoneNumber) => {
    if (phoneNumber != '' && phoneNumber != null) return 'status-on';
    else return 'status-off';
  };
  return (
    <div className="alerts-status mrbml">
      {props.fetchingWaitingArea ? (
        <div className="ui labeled button arrow-pointer">
          <Segment className="icon button square-button borderless bg-transparent mrbnull mrrs arrow-pointer">
            <Dimmer active inverted>
              <Loader size="medium" />
            </Dimmer>
          </Segment>
          <div className="ui basic label no-bold borderless" data-show="true">
            <span className="left-text arrow-pointer">
              {APP.LANGUAGE.ViewOneWaitingArea.AlertsOff.replace('##status##', '')}
            </span>
          </div>
        </div>
      ) : (
        <div
          onClick={showSmsInput}
          className={getStatus(waitingArea.myProviderStatus.monitorContactNumber) + ' ui labeled button '}
          tabIndex="0"
        >
          <div className="ui icon button square-button mrrs">
            <Icon name="mobile alternate" />
          </div>
          <div
            className="ui basic label no-bold borderless"
            data-show={!!waitingArea.myProviderStatus.monitorContactNumber}
          >
            {decideText(waitingArea.myProviderStatus.secondsBeforeSendingSms, true)}
          </div>
          <div
            className="ui basic label no-bold borderless"
            data-show={!waitingArea.myProviderStatus.monitorContactNumber}
          >
            {htmlToReactParser.parse(
              '<span className="left-text">' +
                APP.LANGUAGE.ViewOneWaitingArea.AlertsOff.replace(
                  '##status##',
                  '<span className="bold">' + wordSelector(false) + '</span>'
                ) +
                '</span>'
            )}
          </div>
        </div>
      )}
    </div>
  );
}
